  <!-- New Comment Input -->
  <div class="comment-input-section">
    <htx-textarea-field
      [ctrl]="commentControl"
      [label]="'comments.addNew' | transloco"
      [rows]="3"
    ></htx-textarea-field>
    <div class="input-footer">
      @if (showPublicToggle()) {
        <htx-checkbox-field
          [ctrl]="isPublicControl"
          [label]="'comments.markPublic' | transloco"
        ></htx-checkbox-field>
      }
      <span class="input-footer__spacer"></span>
      @if (showCounter()) {
        <span class="char-counter" [class.near-limit]="isNearLimit">
          {{ remainingChars }} / {{ maxLength() }}
        </span>
      }
      <htx-button
        variant="tertiary"
        icon="send"
        class="clear-button"
        [disabled]="!commentControl.valid"
        (click)="submitComment()"
      >
        {{ 'comments.addButton' | transloco }}
      </htx-button>
    </div>
    @if (commentControl.hasError('required') && commentControl.touched) {
      <span class="error-message">{{ 'comments.enterComment' | transloco }}</span>
    }
  </div>

  <!-- Comments List -->
  <div class="comments-list">
    @if (comments().length === 0) {
      <div class="no-comments">
        <p class="no-comments-text">{{ 'comments.noComments' | transloco }}</p>
      </div>
    } @else {
      <div class="comments-timeline">
        @for (comment of comments(); track comment.id; let isLast = $last) {
          <div class="comment-card"
               [class.last-comment]="isLast"
               [class.comment-approval]="comment.type === 'APPROVAL'"
               [class.comment-rejection]="comment.type === 'REJECTION'">
            <div class="comment-connector"></div>
            <div
              class="comment-avatar"
              [style.background]="getAvatarColor(comment.author)"
              [title]="comment.author"
            >
              @if (comment.avatarUrl) {
                <img [src]="comment.avatarUrl" [alt]="comment.author" />
              } @else {
                <span class="avatar-initials">{{ getInitials(comment.author) }}</span>
              }
            </div>

            <div class="comment-content">
              <div class="comment-header-info">
                <div class="author-info">
                  <span class="comment-author">{{ comment.author }}</span>
                  @if (comment.isPublic) {
                    <span class="comment-badge comment-badge--public">{{ 'comments.public' | transloco }}</span>
                  }
                  @if (comment.type === 'APPROVAL') {
                    <span class="comment-badge comment-badge--approval">{{ 'comments.approved' | transloco }}</span>
                  } @else if (comment.type === 'REJECTION') {
                    <span class="comment-badge comment-badge--rejection">{{ 'comments.rejected' | transloco }}</span>
                  }
                </div>
                <span class="comment-date">
                  {{ formatDate(comment.date) }}
                </span>
              </div>

              <div class="comment-body">
                <div class="comment-text">{{ comment.text }}</div>
              </div>
            </div>
          </div>
        }
      </div>

      @if (hasMore()) {
        <div class="load-more-section">
          <htx-button
            variant="tertiary"
            (click)="onLoadMore()"
          >
            {{ 'comments.loadMore' | transloco }}
          </htx-button>
        </div>
      }
    }
  </div>
